import { UserDto } from '../../../api-client';
import { useForm, UseFormReturn } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export type EditUserInfoFormValues = {
  name: string;
  email: string;
  operatorId: string;
};

type UseEditUserInfoForm = (user: UserDto) => UseFormReturn<EditUserInfoFormValues>;

export const useEditUserInfoForm: UseEditUserInfoForm = (user) => {
  const schema = yup.object().shape({
    email: yup
      .string()
      .min(3, 'Email must be at least 3 characters long')
      .email('Email is invalid'),
    name: yup.string().min(1, 'Displayed name must be at least 1 character long'),
    operatorId: yup.string().optional().default(''),
  });

  return useForm({
    resolver: yupResolver(schema),
    mode: 'onChange',
    defaultValues: {
      name: user.name,
      email: user.email as string,
      operatorId: user.operatorId ?? '',
    },
  });
};
